import React from "react";
import { MasterConfigs } from "../../../../../../interfaces/entity";
import MasterComponent from "../../../../../../components/Forms";
import { Button, Typography } from "antd";
const { Text } = Typography;

const RecuringComponents = () => {
    const config: MasterConfigs = {
        api: () => '/recurring-components',
        modalTitle: () => "Recuring Components",
        isActionTab: true,
        tableProps: {
            scroll: { y: 530 },
        },
        getColumns: () => [
            {
                title: 'Order',
                dataIndex: 'order',
                width: 100,
                fixed: 'left',
                align: 'center',
            },
            {
                title: 'Component Name',
                dataIndex: 'name',
                key: 'name',
                width: 200,
                fixed: 'left',
            },
            {
                title: 'Component Type',
                dataIndex: 'componentType',
                key: 'componentType',
                width: 200,
                fixed: 'left',
                render: (text: any) => <span style={{ textTransform: 'capitalize' }}>{text}</span>
            },
            {
                title: 'Maximum Limit (Year)',
                dataIndex: 'maxLimit',
                key: 'maxLimit',
                width: 200,
                align: 'center',
            },
            {
                title: 'Tax Exempted',
                dataIndex: 'taxExempted',
                key: 'taxExempted',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'BOB',
                dataIndex: 'bob',
                key: 'bob',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'Arrears',
                dataIndex: 'computationArrears',
                key: 'computationArrears',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'Customization',
                dataIndex: 'customization',
                key: 'customization',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'Earnings',
                dataIndex: 'earnings',
                key: 'earnings',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'Separate Statement',
                dataIndex: 'separateStatement',
                key: 'separateStatement',
                width: 200,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'Hide Component',
                dataIndex: 'hideComponent',
                key: 'hideComponent',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'Annual Salary',
                dataIndex: 'annualSalary',
                key: 'annualSalary',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'LOP',
                dataIndex: 'lop',
                key: 'lop',
                width: 150,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            },
            {
                title: 'Special Allowance',
                dataIndex: 'specialAllowance',
                key: 'specialAllowance',
                width: 200,
                render: (text: any) => text ? 'Yes' : 'No',
                align: 'center',
            }
        ],
        getFormColumns: () => [
            {
                label: "Component Type",
                name: "componentType",
                type: "select",
                children: [{ name: 'Fixed', value: 'fixed' },
                { name: 'Allowance', value: 'allowance' },
                { name: 'Deduction', value: 'deduction' },
                { name: 'Reimbursement', value: 'reimbursement' },
                { name: 'Bonus', value: 'bonus' },
                { name: 'Contribution', value: 'contribution' },
                { name: 'Total Cost', value: 'totalCost' }
                ],
                rules: [{ required: true, message: "Please select component type!" }],
            },
            {
                label: "Component Name",
                name: "name",
                type: "text",
                rules: [{ required: true, message: "Please enter component name!" }],
            },
            {
                span: 8
            },
            {
                label: 'Maximum Limit per annum',
                name: 'maxLimit',
                type: 'number',
            },
            {
                label: 'Order',
                name: 'order',
                type: 'number',
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 12,
                inputTextAreaProps: { rows: 1 }
            },
            {
                label: 'This component is tax exempted (Non taxable)',
                name: 'taxExempted',
                type: 'checkbox',
                span: 24,
            },
            {
                label: 'This element is a part of the Bouquet of Benefits (BOB) of the Flexible Benefit Plan (FBP).',
                name: 'bob',
                span: 24,
                type: 'checkbox',
            },
            {
                label: 'Add this component to the computation of arrears.',
                span: 24,
                name: 'computationArrears',
                type: 'checkbox',
                toolTipProps: {
                    children: <Button type="link">Explain?</Button>,
                    title: 'If chosen, the component will be included in calculating the arrear amount (in the event of a salary modification, release of pending salaries, etc.), and the appropriate arrear amount will be determined.'
                }
            },
            {
                span: 24,
                label: 'Allow customization and employee level overrides for this component.',
                name: 'customization',
                type: 'checkbox',
            },
            {
                label: 'Include this item in your earnings and deductions.',
                toolTipProps: {
                    children: <Button type="link">Explain?</Button>,
                    title: "To include an allowance in earnings and deductions, choose this option. This is a component of the gross monthly wage, but it is not included in the calculation of an employee's net pay.For instance, food coupons are handed out separately as cards, vouchers, or coupons even if they have a monetary value.They are also included in the gross monthly compensation of the employees.That being said, this element is not included in the Net Pay that is distributed as remuneration."
                },
                name: 'earnings',
                type: 'checkbox',
                span: 24,
            },
            {
                label: 'Pay this component separately with its own statement.',
                name: 'separateStatement',
                type: 'checkbox',
                span: 24,
                toolTipProps: {
                    children: <Button type="link">Explain?</Button>,
                    title: "After the payroll for a particular month is finalized, the payroll system will generate a separate payment statement for this component, which can be paid in addition to the employees' usual salaries."
                }
            },
            {
                label: 'Hide component in payroll (and exclude from gross earnings calculation in Payslip)',
                name: 'hideComponent',
                type: 'checkbox',
                span: 24,
            },
            {
                label: 'Pay this amount in addition to the employee\'s annual salary.',
                name: 'annualSalary',
                type: 'checkbox',
                span: 24,
            },
            {
                label: 'The component value is unaffected by loss of pay (LOP) due to attendance or unpaid leave.',
                name: 'lop',
                type: 'checkbox',
                span: 24,
            },
            {
                label: 'Adjust the difference amount (Paid value - Actual value due to LOP) against special allowance.',
                name: 'specialAllowance',
                type: 'checkbox',
                span: 24,
            },
            {
                label: "PF Exempted",
                name: "pf_exempted",
                type: "checkbox",
                span: 24,
            },
            {
                label: "ESI Exempted",
                name: "esi_exempted",
                type: "checkbox",
                span: 24,
            },
            {
                label: "PT Exempted",
                name: "pt_exempted",
                type: "checkbox",
                span: 24,
            },
            {
                label: "TDS Exempted",
                name: "tds_exempted",
                type: "checkbox",
                span: 24,
            }
        ],
        actions: [
            { actionType: 'Add', name: 'Add Component' },
        ],
    }
    return <MasterComponent config={config} isModal={true} />
}

export default RecuringComponents;